<template>
  <div class="resGray lighten-6">
    <delete-checks
      v-if="!viewCheck"
      @setDate="setDate"
      :previousProperty="selectedProperty"
      :previousDate="selectedDate"
      @setProperty="setProperty"
      @openCheckDetails="getInfo">
    </delete-checks>
    <distribute-details
      v-if="viewCheck"
      @returnToGrid="refreshGrid"
      :currentCheck="currentCheck"
      :depositDetails="depositDetails">
    </distribute-details>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DeleteChecks from './DeleteCashReceiptsComponents/DeleteChecks'
import DistributeDetails from './DeleteCashReceiptsComponents/DistributeDetails'
import moment from 'moment'

export default {
  components: {
    DeleteChecks,
    DistributeDetails
  },
  data () {
    return {
      depositDetails: {},
      currentCheck: '',
      viewCheck: false,
      selectedProperty: {},
      selectedDate: moment().startOf('month')
    }
  },
  methods: {
    ...mapActions(['initializeStoreItem', 'fetchData']),
    getInfo (val) {
      this.fetchData({ newPage: 'BankDepositSlipDraftsFullInfo', params: { CompanyId: val.companyId, BankAccountCode: val.bankAccountCode, BankDepositSlipId: val.depositSlipId } }).then(() => {
        this.depositDetails = this.currentData('BankDepositSlipDraftsFullInfo')
        if (this.viewCheck === true) {
          this.fetchData({ newPage: 'BankDepositDetailsDistribution', params: { Lease: val.payer, BankDepositId: val.depositId } }).then(() => {
            this.viewCheck = true
            this.currentCheck = val.depositId
          })
        } else {
          this.viewCheck = true
          this.currentCheck = val.depositId
        }
      }).catch(error => { console.log(error.response) })
    },
    setDate (val) {
      this.selectedDate = val
    },
    setProperty (val) {
      if (val.value !== null) {
        this.selectedProperty = val
      }
    },
    refreshGrid () {
      this.fetchData({newPage: 'BankDepositDetailsDelete', params: { Property: this.selectedProperty.value, AsOfDate: this.selectedDate }}).then(() => {
        this.viewCheck = false
      }).catch(error => { console.log(error.response) })
    }
  },
  computed: {
    ...mapGetters(['currentData'])
  }
}
</script>

<style lang="scss" scoped>
</style>
